var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArupRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 535.8 141.7",
    style: {
      enableBackground: "new 0 0 535.8 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E61E28;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.9,141.7c-30.4,0-43.6-13.7-48.7-21.9c-5.9-9.5-6.6-22.3-6.6-32.4V21.2c0-0.6,0-1.3,0-1.9 c0.1-6.9,0.2-13.4-10.5-13.8h-3.4V0h55l0,5.6l-1,0c-4.1,0-7.2,1-9.4,3.2c-2.6,2.6-4,6.8-4,12.4V94c0,24.7,10.7,37.1,31.9,37.1 c12,0,22-3.5,28.3-9.9c10.2-10.5,11-24.1,11-40.8V21c0-8.8-0.9-15.5-11.9-15.5h-2.9V0h40.5v5.5h-1.7c-8.1,0-12.8,2.5-12.8,15.5 v60.4C400.7,122,383.1,141.7,346.9,141.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483,138.8h-55v-5.5l0.9,0c12.9-0.4,13.5-4.5,13.5-16.3V21.1c0-12.3-0.5-15.2-13-15.6l-0.9,0V0h56.1 c33.2,0,50.5,19.4,50.5,38.6c0,22-19.6,39.2-44.6,39.2l-12.4-0.2v-9.7c0,0,4.7-0.1,6.4-0.1c15.4,0,23.3-11.6,23.3-28.9 c0-18-11.6-30.1-28.8-30.1l-11.1,0v110.4c0,11.6,2.1,13.7,14,14.1l0.9,0L483,138.8L483,138.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.2,138.8h-39.6l-42.4-64.5v-7.9l0.9-0.1c14.9-1.6,28.8-10.1,28.8-29.5c0-16.2-11.7-27.5-28.4-27.5h-11.4 v109.8c0,12,5.5,13.1,13.2,13.5l0.9,0v6.1h-53.8v-5.6l0.9-0.1c11.7-0.6,13.3-3.6,13.3-14V19.6c-0.4-12.3-1.2-13.9-13.3-14.1 l-0.9,0V0h57.9c22.1,0,47.9,9.7,47.9,37.1c0,16.3-9.9,28-29.4,34.8l22,32.5c2.4,3.7,11.2,14.4,15.2,18.7c7.5,8.1,13,9.2,16.5,10 l1.6,0.4L281.2,138.8L281.2,138.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.9,138.8H87.4v-5.4l0.9,0c6.4-0.2,10.4-1.6,10.4-7.9c0-2.8-2.2-8.3-3.4-11.2l-8.5-20.4H39.5l-8.7,19.8 c-2.9,6.6-3.7,8.9-3.7,12c0,4.5,0,7.5,10.5,7.7l0.9,0v5.4H0.7v-5.4l0.9,0c7.5-0.2,11.4-4,16.7-16.3L69.6,0h5.3l0.2,0.6l51.5,121.2 c3.7,9,4.6,11.2,12.4,11.5l0.9,0L139.9,138.8L139.9,138.8z M43.3,84.4H83l-19.4-47L43.3,84.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArupRed);
export default __webpack_public_path__ + "static/media/arup_red.dc5573649c214851458a618a98b49bdf.svg";
export { ForwardRef as ReactComponent };